export const HOME = "/";
export const REG_01 = "reg-01";
export const REG_02 = "reg-02";
export const REG_PERSONAL_NUMBER = "reg-personal-number";
export const REG_INSERT_CARD = "reg-insert-card";
export const REG_REMOVE_CARD = "reg-remove-card";
export const REG_REASON_BUTTON = "reg-reason";
export const REG_LAST_NAME = "reg-last-name";
export const REG_NAME = "reg-name";
export const REG_INUSRANCE = "reg-insurance";
export const REG_SUMMARY = "reg-summary";
export const PAGE_ERROR = "error";
export const PAGE_ERROR_NOT_ENABLED = "error-not-enabled";
export const PAGE_ERROR_NOT_FOUND = "error-not-found";
export const PAGE_ERROR_PAGE_EXPIRED = "error-page-expired";
export const PAGE_ERROR_LOG = "error-log";
export const PAGE_ERROR_LOG_TERMINAL = "error-log-terminal";
export const PAGE_HW_SW_INFO = "hw-sw-info";
export const PAGE_TEST_SOUND_LED = "test-sound-led";
export const PAGE_BRIGHTNESS = "brightness";
export const PAGE_CAMERA_TEST = "camera-test";
export const PAGE_TEST = "test";
export const PAGE_INFO_PANEL = "info-panel";

export const PAGE_TERMINAL_ID = "terminal-id";
export const PAGE_API_ID = "api-url";

export const STATE_MAX = 1;
export const STATE_MIN = 2;

export const STATE_ENABLED = 1;
export const STATE_DISABLED = 0;

export const SCREEN_UNKNOWN = 0;
export const SCREEN_RPIV1 = 1;
export const SCREEN_RPIV2 = 2;
export const SCREEN_WAVESHARE = 3;
export const SCREEN_PHONE = 4;

export const SCREEN_TV_720 = 5;
export const SCREEN_TV_768 = 6;
export const SCREEN_TV_1080 = 7;
export const SCREEN_TV_2160 = 8;

export const HOME_INDEX = 0;
export const REG_01_INDEX = 1;
export const REG_02_INDEX = 2;
export const REG_SUMMARY_INDEX = 3;

export const REG_RPI_01_INDEX = 1;
export const REG_RPI_INSERT_CARD_INDEX = 1;
export const REG_RPI_REASON_BUTTON_INDEX = 2;
export const REG_RPI_REMOVE_CARD_INDEX = 3;

export const REG_RPI_INUSRANCE_COMPANY_INDEX = 2;
export const REG_RPI_PERSONAL_NUMBER_INDEX = 3;
export const REG_RPI_LAST_NAME_INDEX = 4;
export const REG_RPI_NAME_INDEX = 5;
export const REG_RPI_SUMMARY_INDEX = 6;

export const BUTTON_ALIGNMENT_LEFT = 1;
export const BUTTON_ALIGNMENT_CENTER = 0;
export const BUTTON_ALIGNMENT_RIGHT = 2;

export const OPERATION_RESTART = "restart";
export const OPERATION_SHUTDOWN = "shutdown";

export const IMAGE_TYPE_INSURANCE_CARD = "karticka";
export const IMAGE_TYPE_ID = "op";
export const IMAGE_TYPE_DRIVER_LICENCE = "dl";

export const DOC_TYPE_INSURANCE_CARD = 1;
export const DOC_TYPE_ID = 2;
export const DOC_TYPE_DRIVER_LICENCE = 3;
export const DOC_TYPE_NO_CARD = 4;

export const PAGE_TERMINAL_ID_HOME = 0;
export const PAGE_TERMINAL_ID_BUTTONS = 1;
export const PAGE_TERMINAL_ID_INSERT_CARD = 2;
export const PAGE_TERMINAL_ID_REMOVE_CARD = 3;
export const PAGE_TERMINAL_ID_DOCTORS = 4;
export const PAGE_TERMINAL_ID_INFO_PANEL = 5;
export const PAGE_TERMINAL_ID_TOP_NESTED = 6;

export const MODE_NOT_SET = 0;
export const MODE_TERMINAL = 1;
export const MODE_INFO_PANEL = 2;
export const MODE_EMULATOR = 3;
export const MODE_TABLET = 4; //terminal bez ctecky

export const INFO_PANEL_ROWS_ON_SCREEN = 7;

export const INFO_PANEL_TYPE_SINGLE = 1;
export const INFO_PANEL_TYPE_GROUPED = 2;

export const INFO_PANEL_REFERENCE_TYPE_TERMINAL = 1;
export const INFO_PANEL_REFERENCE_TYPE_QUEUE = 2;
export const INFO_PANEL_REFERENCE_TYPE_SELECTIVE_QUEUE = 3;

export const ORDINATION_STATE_CLOSED = 1;
export const ORDINATION_STATE_EXAMINATION = 2;
export const ORDINATION_STATE_CALL_IN = 3;
export const ORDINATION_STATE_WAIT_FOR_CALL = 4;
export const ORDINATION_STATE_RETURN_PATIENT_WAITING_LIST = 5;

export const ORDINATION_DIRECTION_NOT_SET = -1;
export const ORDINATION_DIRECTION_ORIGINAL_BEHAVIOUR = 0;
export const ORDINATION_DIRECTION_RIGHT = 1;
export const ORDINATION_DIRECTION_RIGHT_IN_CALL = 2;
export const ORDINATION_DIRECTION_LEFT = 3;
export const ORDINATION_DIRECTION_LEFT_IN_CALL = 4;
export const ORDINATION_DIRECTION_UP = 5;
export const ORDINATION_DIRECTION_UP_IN_CALL = 6;
export const ORDINATION_DIRECTION_DOWN = 7;
export const ORDINATION_DIRECTION_DOWN_IN_CALL = 8;

export const NAME_FORMAT_TYPE_SURNAME_NAME = 1;
export const NAME_FORMAT_TYPE_SURNAME_NAME_FIRST_LETTER = 2;
export const NAME_FORMAT_TYPE_SURNAME_NAME_FIRST_LETTER_DOB = 6;
export const NAME_FORMAT_TYPE_NAME_SURNAME_FIRST_LETTER = 3;
export const NAME_FORMAT_TYPE_NAME_SURNAME_FIRST_LETTER_DOB = 7;
export const NAME_FORMAT_TYPE_MONOGRAM = 4;
export const NAME_FORMAT_TYPE_MONOGRAM_DOB = 5;
export const NAME_FORMAT_TYPE_IDENTIFICATION = 8;
export const NAME_FORMAT_TYPE_IDENTIFICATION_SURNAME_NAME = 9;
export const NAME_FORMAT_TYPE_IDENTIFICATION_SURNAME_NAME_FIRST_LETTER = 10;
export const NAME_FORMAT_TYPE_IDENTIFICATION_NAME_SURNAME_FIRST_LETTER = 11;

const pageTerminalArray = [
  {
    index: HOME_INDEX,
    route: HOME,
  },
  {
    index: REG_RPI_INSERT_CARD_INDEX,
    route: REG_INSERT_CARD,
  },
  {
    index: REG_RPI_REASON_BUTTON_INDEX,
    route: REG_REASON_BUTTON,
  },
  {
    index: REG_RPI_REMOVE_CARD_INDEX,
    route: REG_REMOVE_CARD,
  },
  /*,
  {
    index: REG_RPI_INUSRANCE_COMPANY_INDEX,
    route: REG_INUSRANCE,
  },
  {
    index: REG_RPI_PERSONAL_NUMBER_INDEX,
    route: REG_PERSONAL_NUMBER,
  },
  {
    index: REG_RPI_LAST_NAME_INDEX,
    route: REG_LAST_NAME,
  },
  {
    index: REG_RPI_NAME_INDEX,
    route: REG_NAME,
  },
  {
    index: REG_RPI_SUMMARY_INDEX,
    route: REG_SUMMARY,
  },*/
];

const pageArray = [
  {
    index: HOME_INDEX,
    route: HOME,
  },
  {
    index: REG_01_INDEX,
    route: REG_01,
  },
  {
    index: REG_02_INDEX,
    route: REG_02,
  },
  {
    index: REG_SUMMARY_INDEX,
    route: REG_SUMMARY,
  },
];
export function getIndexForPage(route) {
  let index = -1;

  const data = isTerminal() ? pageTerminalArray : pageArray;
  if (data) {
    //v ramci pathname mi prijde /reg-insert-card a potrebuji mit ve formatu reg-insert-card
    if (route.startsWith("/")) {
      route = route.slice(1);
    }

    index = data.find((item) => item.route === route)?.index ?? -1;
  }
  return index;
}

export function getPathForRoute(route) {
  return `/${route}`;
}

export const GONG_SOUND = "/sound/gong.mp3";

export const ENV_CMV = "cvm";
export const ENV_VK = "vk";

export const HW_CONTEXT_TERMINAL = 0;
export const HW_CONTEXT_MOBILE = 1;

export const SPLASH_TIME = process.env.REACT_APP_SPLASH_INTERVAL; //2s-0s
export const PAGE_EXPIRED_TIME = process.env.REACT_APP_EXPIRED_INTERVAL * 60 * 1000; // minute * sec * ms
export const QUEUE_CHANGE_INTERVAL = process.env.REACT_APP_QUEUE_CHANGE_INTERVAL * 1000; //  sec * ms
export const EXIT_TEXT_INTERVAL = process.env.REACT_APP_EXIT_TEXT_INTERVAL * 1000; //  sec * ms
export const PAGE_REG_SUMMARY_TERMINAL_TIME = process.env.REACT_APP_REG_SUMMARY_TERMINAL_EXPIRED_INTERVAL * 1000; // sec * ms
export const LOG_DELETE_INTERVAL = 5 * 1000; // sec * ms
export const SCREEN_SAVER_CHECK_INTERVAL = 60; // sec -zde se nenasobi 1000 protoze je tam lagika do cele minuty
export const DEFAULT_BLINK_COUNT = 5;
export const DEFAULT_BLINK_DELAY_IN_MS = 1500;
export const DEFAULT_MAX_ERROR_RESTART_COUNT = 3;

export const NBSP_TAG = "\u00A0"; //v js &nbsp; ma tuto hodnotu

export const MODE_DEV = "DEV";
export const MODE_PROD = "PROD";
export const MODE_PREP = "PREP";

export const SS_REG_TYPE = "BB1DA18946F69";
export const SS_UID = "83723B14C3E5D";
export const SS_START_TIME = "CEA63AA23571B";
export const LS_FIRST_NAME = "A6F157FA17E7A";
export const LS_LAST_NAME = "ED7E4F627FD93";
export const LS_INSURANCE = "7A92816762A89";
export const LS_PERSONAL_NUMBER = "623BCF1445C9D";
export const LS_EMAIL = "B78EA726D3D2E";

//app settings
export const LS_ERROR_RESTART_COUNT = "d41d8cd98f00b204e9800998ecf8427e";
export const LS_ANIMATION_DISABLED = "9B4A64D967DE6285";
export const LS_SOUND_ENABLED = "b1e8d5d2baa6546a2ee6b5fede3a35b0";
export const LS_CURSOR_ENABLED = "c39185722fd94f458b6dbd62c8261ece";
export const LS_PHOTO_CAPTURE_TEST_ENABLED = "c38a2569cce25baba75c75b5ce66d2a2";
export const LS_THEME = "792b63dfa61eb95aad49aafdeaa2b7ae";
export const LS_WITHOUT_CARD_ENABLED = "d5364e3c6df05cb2a07c335943b0b16e";

export const REG_TYPE_MOBILE_APP_QR = 2;
export const REG_TYPE_MOBILE_APP_NFC = 3;
export const REG_TYPE_MOBILE_APP_RPI = 4;

export const TERMINAL_BURES = "h7pj62fglimtzaql"; //3 page
export const TERMINAL_BURESOVA = "usids11fztuss5gy"; //2 page
export const TERMINAL_JA = "fbs7lgrsrdewz3u0"; //1 page
export const TERMINAL_PARDUBICE = "f1xys6k17aps230b"; //3 page
export const TERMINAL_MINARIKOVA = "j7bcxww8la0qqb0q"; //1 page dlouhe nazvy fronty
export const TERMINAL_UID = TERMINAL_BURES;

export const TOPIC_MQTTT_LOCAL = "rpi/messages";
export const LOCAL_MESSAGE_CARD_INSERTED = "L_M_C_I";
export const LOCAL_MESSAGE_CARD_REMOVED_TOO_EARLY_ERROR = "L_M_C_R_T_E_E";
export const LOCAL_MESSAGE_CARD_REMOVED = "L_M_C_R";
export const LOCAL_MESSAGE_PHOTO_CREATED = "L_M_P_C";
export const LOCAL_MESSAGE_PHOTO_ERROR = "L_M_P_E";
export const LOCAL_MESSAGE_TERMINAL_CLOSED = "L_M_T_C";
export const LOCAL_MESSAGE_TERMINAL_OPEN = "L_M_T_O";
export const LOCAL_MESSAGE_TERMINAL_ERROR_PAGE_ENABLED = "L_M_T_E_P_E";
export const LOCAL_MESSAGE_TERMINAL_ERROR_PAGE_DISBLED = "L_M_T_E_P_D";
export const LOCAL_MESSAGE_TERMINAL_SERVICE_PAGE_ENABLED = "L_M_T_S_P_E";
export const LOCAL_MESSAGE_TERMINAL_SERVICE_PAGE_DISBLED = "L_M_T_S_P_D";
export const LOCAL_MESSAGE_TERMINAL_SEND_UI_LOG_TO_API = "L_M_T_S_U_L_T_A";

export const LOCAL_MESSAGE_TERMINAL_INFO_PANEL_CALL_PATIENT = "L_M_T_I_P_C_P";
export const LOCAL_MESSAGE_TERMINAL_INFO_PANEL_STATE_CHANGE = "L_M_T_I_P_S_CH";
export const LOCAL_MESSAGE_TERMINAL_INFO_PANEL_PATIENT_ADDED = "L_M_T_I_P_P_A";
export const LOCAL_MESSAGE_TERMINAL_INFO_PANEL_REFRESH_DATA = "L_M_T_I_P_R_D";

export function isProduction() {
  return process.env.REACT_APP_MODE === MODE_PROD ? true : false;
}

export function isPreproduction() {
  return process.env.REACT_APP_MODE === MODE_PREP ? true : false;
}

export function isDebugMode() {
  return process.env.REACT_APP_MODE === MODE_DEV ? true : false;
}

export const ENV = process.env.REACT_APP_MODE;

export function isTerminal() {
  if (isMobileAppTest()) {
    return false;
  }
  return process.env.REACT_APP_HW_CONTEXT == HW_CONTEXT_TERMINAL ? true : false;
}

export function isVk() {
  if (isMobileAppTest()) {
    return false;
  }
  return process.env.REACT_APP_ENV == ENV_VK ? true : false;
}

//pro testovani funkcnosti mobilni aplikace
function isMobileAppTest() {
  if (isDebugMode()) {
    return false;
  } else {
    return false;
  }
}

function getAppVersion() {
  if (process.env.REACT_APP_BUILD_ID) {
    return process.env.REACT_APP_VERSION + "." + process.env.REACT_APP_BUILD_ID;
  } else {
    return process.env.REACT_APP_VERSION;
  }
}

const LOCAL_API_URL = "https://localhost:44341/api";
const PRODUCTION_API_URL = "https://qapi.vloztekarticku.cz/api";
//const PRODUCTION_API_URL = "https://testqapi.vloztekarticku.cz/api";
export const API_URL = process.env.REACT_APP_API_URL; //isProduction() ? PRODUCTION_API_URL : LOCAL_API_URL;
export const TERMINAL_APP_URL = process.env.REACT_APP_TERMINAL_APP_PUBLIC_URL;
export const TERMINAL_APP_SERVICE_WEB_SOCKET_URL = process.env.REACT_APP_TERMINAL_APP_WEB_SOCKET_URL;
export const APP_URL = process.env.REACT_APP_PUBLIC_URL;
export const APP_VERSION = getAppVersion();
